import React from 'react';

import { useUIContext } from 'state/ui';

import { Price, PriceAndCaloriesText, PriceCaloriesSeparator } from './price-and-calories.styled';
import { PriceAndCaloriesProps } from './types';

export const PriceAndCalories: React.FC<PriceAndCaloriesProps> = ({ price, calories }) => {
  const { formatCurrencyForLocale } = useUIContext();

  if (!price && !calories) {
    return null;
  }

  const formattedPrice = price && `+${formatCurrencyForLocale(price)}`;
  return (
    <PriceAndCaloriesText>
      {!!formattedPrice && (
        <>
          <Price>{formattedPrice}</Price>
          <PriceCaloriesSeparator>•</PriceCaloriesSeparator>
        </>
      )}
      {calories}
    </PriceAndCaloriesText>
  );
};

export default PriceAndCalories;
